import store from '../store'
import router from '../router'
import * as types from '../store/mutation-types'

let utils = {
    /**
     * 全局路由钩子处理函数
     * @param  {[Object]}   options.meta [路由上的参数]
     * @param  {[String]}   options.path [路由要进入的路径地址]
     * @param  {[String]}   from         [当前导航正要离开的路由]
     * @param  {Function}   next         [进行管道中的下一个钩子]
     */
    globalRouterBeforeEach ({path, meta, fullPath}, from, next) {
        let { authorizd = true } = meta
        if (authorizd && !store.getters.authorizd && path !== store.getters.loginRouter) { // 未登录状态
            let tokon = null
            if (path.indexOf(store.getters.tokonMark) === 0) { // 跳转路径是否带tokon参数
                // 获得链接上的TOKON值
                tokon = path.substring(5, path.length)
                // 本地存储TOKON
                utils.saveTokon(tokon)
                // MARK 标识过来的设置 path 为根目录
                path = store.getters.rootRoute
            } else { // 本地获取是否有tokon
                tokon = utils.getCookie(store.getters.tokonKey)
            }
            if (fullPath.indexOf('/bill/adjust/list') >= 0 || fullPath.indexOf('/bill/provider/list') >= 0) {
                tokon = "adjust"
                // 本地存储TOKON
                utils.saveTokon(tokon)
            }
            // 有tokon时
            if (tokon && tokon.length > 0) {
                // 1、将tokon存放到vuex中
                store.commit(types.UPDATE_TOKON, tokon)
                // 2、改变authorizd状态
                store.commit(types.UPDATE_AUTHORIZD, true)
                // 3、路由跳转到默认页面
                // next(store.getters.rootRoute)
                next({path: path})
            } else { // 无Tokon时，跳转到登录页面
                next({ path: store.getters.loginRouter, query: {redirect: path} })
            }
        } else if (store.getters.authorizd && path === store.getters.loginRouter) { // 已登录，再跳转到login路由的拦截
            next(store.getters.rootRoute)
        } else {
            next()
        }
            // next()
    },
    /**
     * 本地存储tokon
     * @param  {[type]} tokon [description]
     * @return {[type]}       [description]
     */
    saveTokon (tokon) {
        // 设置有效期15天
        let expireDays = 1000 * 60 * 60 * 24 * 15
        utils.setCookie(store.getters.tokonKey, tokon, expireDays)
    },
    /**
     * 设置cookie
     */
    setCookie (key, value, expiredays) {
        var exdate = new Date()
        exdate.setDate(exdate.getDate() + expiredays)
        document.cookie = key + "=" + escape(value) + ((expiredays == null) ? "" : ";expires=" + exdate.toGMTString())
    },
    /**
     * 获取cookie
     */
    getCookie (name) {
        var reg = new RegExp("(^| )" + name + "=([^;]*)(;|$)")
        var arr = document.cookie.match(reg)
        if (arr) {
            return (arr[2])
        } else {
            return null
        }
    },
    /**
     * 删除cookie
     */
    delCookie (name) {
        var exp = new Date()
        exp.setTime(exp.getTime() - 1)
        var cval = utils.getCookie(name)
        if (cval != null) {
            document.cookie = name + "=" + cval + ";expires=" + exp.toGMTString()
        }
    },
    /**
     * 退出登录
     */
    loginOut (tokon) {
        // 1、改变授权状态
        store.commit(types.UPDATE_AUTHORIZD, false)
        // 2、删除cookie
        utils.delCookie(store.getters.tokonKey)
        if (tokon && tokon.indexOf('LYT') > -1) {
            // 跳转到路易通 
            window.location.href = "http://" + location.host
        } else {
            // 3、跳转到登陆页
            router.replace(store.getters.loginRouter)
        }
    },
    /**
     * 读取路由的配置
     * @param  {[fullPath]} fullPath [路由全路径]
     * @param  {[string]} routeName [路由名称]
     * @return {[object]}           [路由的配置对象]
     */
    readRouteConfig (fullPath) {
        let config = localStorage.getItem(store.getters.localConfigKey)
        if (!config) {
            return null
        }
        config = config ? JSON.parse(config) : config
        config = config.config ? config.config : config
        let routeConfig = null // 路由的配置

        for (let i in config) {
            if (config[i]['children']) {
                for (let j in config[i]['children']) {
                    let routePath = config[i]['children'][j]['type'] + '/' + config[i]['children'][j]['path']  
                    if (fullPath.indexOf(routePath) > 0) {
                        routeConfig = config[i]['children'][j]
                        break
                    }
                }
            } else {
                routeConfig = config[i]
            }
        }
        return routeConfig
    },
    /**
     * 读取当前页面的配置
     * @param routeConfig 路由的配置
     * @param pageName 页面的名称
     */
    readPageConfig (routeConfig,pageName) {
        let pageConfig = null // 页面的配置
        if (routeConfig && routeConfig.page) {
            for (let i in routeConfig.page) {
                if (routeConfig.page[i]['label'] === pageName) {
                    pageConfig = routeConfig.page[i]
                    break
                }
            }
        }
        return pageConfig
    },
    chars : ['0','1','2','3','4','5','6','7','8','9','A','B','C','D','E','F','G','H','I','J','K','L','M','N','O','P','Q','R','S','T','U','V','W','X','Y','Z'],
    /**
     * 生成随机字符串
     * @param  {[type]} n [description]
     * @return {[type]}   [description]
     */
    generateMixed (n) {
        let res = ""
        for (let i = 0; i < n; i++) {
            let id = Math.ceil(Math.random() * 35)
            res += this.chars[id]
        }
        return res;
    },
    /**
     * 创建uuid
     */
    createUUID () {
        let uuid = new Date().getTime()
        let len = Math.random() * 10 + 1 // 随机字符串的长度
        let rand = this.generateMixed(len)
        uuid += rand
        return uuid
    },
    /**
     * 深度拷贝
     */
    deepClone (obj) {
        let newObj = obj instanceof Array ? [] : {}
        for (let i in obj) {
            newObj[i] = typeof obj[i] === 'object' ? utils.deepClone(obj[i]) : obj[i]
        }
        return newObj
    },
    /**
     * 日期格式转换 
     * @author wxf
     * @time 2017-09-20
     * @param format 【description:格式】
     * @param dateIn 【description:传入的日期】
     */
    dateFormat (format,dateIn) {
        let date = {
            "M+": dateIn.getMonth() + 1,
            "d+": dateIn.getDate(),
            "h+": dateIn.getHours(),
            "m+": dateIn.getMinutes(),
            "s+": dateIn.getSeconds(),
            "q+": Math.floor((dateIn.getMonth() + 3) / 3),
            "S+": dateIn.getMilliseconds()
        };
        if (/(y+)/i.test(format)) {
            format = format.replace(RegExp.$1, (dateIn.getFullYear() + '').substr(4 - RegExp.$1.length))
        }
        for (let k in date) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length === 1 ? date[k] : ("00" + date[k]).substr(("" + date[k]).length))
            }
        }
        return format;
    }
}
export default utils